/**
 * MALYALI Personel Sistemi — Sistem Sabitleri
 *
 * 31 spec kararının koddaki sayısal/string karşılıkları.
 * Bu sabitler tüm modüller tarafından kullanılır.
 *
 * SİSTEM AYARLARI ile İLİŞKİSİ:
 *  Bu dosyadaki sabitler "fabrika varsayılanları"dır.
 *  Çoğu BOSS panelden değiştirilebilir → ayarlar/genel dokümanına yansır.
 *  Kodda her zaman önce ayarlar dokümanı kontrol edilir, yoksa bu varsayılanlar.
 */

// ═══════════════════════════════════════════════════════════════════
// FİRESTORE & FİREBASE (KARAR #1, #2)
// ═══════════════════════════════════════════════════════════════════

/** KARAR #1: Firestore region */
export const FIRESTORE_REGION = 'europe-west3' as const

/** KARAR #2: İlk BOSS, Firebase Console'dan elle oluşturulur (developer seed) */
export const ILK_BOSS_OLUSTURMA_YONTEMI = 'developerSeed' as const

// ═══════════════════════════════════════════════════════════════════
// MAAŞ DÖNEMİ (KARAR #3)
// ═══════════════════════════════════════════════════════════════════

/** KARAR #3: Maaş dönemi başlangıç günü */
export const MAAS_DONEM_BASLANGIC_GUN = 1 as const

/** KARAR #3: Maaş ödeme son günü (sonraki ay) */
export const MAAS_ODEME_SON_GUN = 5 as const

/** KARAR #3: Ay otomatik kapanış saati */
export const AY_KAPANIS_SAATI = '23:59' as const

// ═══════════════════════════════════════════════════════════════════
// YILLIK İZİN (KARAR #4)
// ═══════════════════════════════════════════════════════════════════

/** KARAR #4: Her 6 ayda bir kaç gün eklenir */
export const YILLIK_IZIN_KAZANIM_PERIYOT_AY = 6 as const
export const YILLIK_IZIN_KAZANIM_GUN = 7 as const

/** Tam yıl izin hakkı (12 ay = 14 gün) */
export const YILLIK_IZIN_TAM_YIL_GUN = 14 as const

/** 1 izin günü = kaç saat × saatlik ücret (mevcut HTML formülü) */
export const IZIN_GUN_SAAT_KARSILIGI = 10 as const

// ═══════════════════════════════════════════════════════════════════
// AYLIK İZİN FORMÜLÜ (KARAR #30)
// ═══════════════════════════════════════════════════════════════════

/**
 * KARAR #30: Aylık izin hakkı = floor(tamamlanan vardiya ÷ 6)
 * Mantık: Her 6 vardiyaya 1 izin (haftalık tatil = hafta tatili kuralı)
 */
export const AYLIK_IZIN_VARDIYA_BOLEN = 6 as const

/** Default tam zamanlı (referans için, hesabı etkilemez) */
export const DEFAULT_AYLIK_IZIN_VARSAYILAN = 4 as const

// ═══════════════════════════════════════════════════════════════════
// MOLA (KARAR #28, spec madde 7)
// ═══════════════════════════════════════════════════════════════════

/** Spec: 10 saatlik vardiyada 1.5 saat mola hakkı */
export const MOLA_HAK_DAKIKA = 90 as const         // 1.5 saat

/** KARAR #28: Mola minimum süresi yok (esnek) */
export const MOLA_MIN_DAKIKA = 0 as const

/** Mola sayacı uyarı eşiği (1.5 saate yaklaşınca) */
export const MOLA_UYARI_DAKIKA = 75 as const       // 15 dakika kala uyar

// ═══════════════════════════════════════════════════════════════════
// VARDİYA & GİRİŞ-ÇIKIŞ (KARAR #5, #6, #7, #8, #9, #29, #31)
// ═══════════════════════════════════════════════════════════════════

/** Geç gelme / erken çıkma toleransı */
export const TOLERANS_DAKIKA = 15 as const

/** Aynı tipten 3'üncü tekrarda uyarı */
export const UYARI_TEKRAR_LIMITI = 3 as const

/** No-show eşikleri (Sorumlu/BOSS bildirimleri için) */
export const NO_SHOW_30DK_DAKIKA = 30 as const
export const NO_SHOW_1SAAT_DAKIKA = 60 as const
export const NO_SHOW_3SAAT_DAKIKA = 180 as const

/** KARAR #9: No-show ek ceza = 1 günlük yevmiye = 10 saat × ücret */
export const NO_SHOW_EK_CEZA_SAAT = 10 as const

/** KARAR #7: Auto-checkout eşiği */
export const AUTO_CHECKOUT_SAAT = 12 as const

/** Vardiya bitimi sonrası "çıkış unutuldu mu?" eşiği (spec madde 6.10) */
export const VARDIYA_BITISI_KONTROL_DAKIKA = 30 as const

/** KARAR #29: Günde 8+ giriş-çıkış şüpheli */
export const COKLU_GIRIS_LIMITI = 8 as const

// ═══════════════════════════════════════════════════════════════════
// GPS & ŞUBE
// ═══════════════════════════════════════════════════════════════════

/** Spec madde 2.3: Şube yarıçap (metre) */
export const SUBE_YARICAP_METRE = 50 as const

/** GPS doğruluk şüpheli eşiği (metre) — daha düşük accuracy = mock olabilir */
export const GPS_SUPHE_ACCURACY_METRE = 100 as const

/** Ani lokasyon değişimi anomali eşiği (5 dk içinde 1 km uzakta) */
export const ANOMALI_HIZ_KM_PER_5DK = 1 as const

// ═══════════════════════════════════════════════════════════════════
// SETUP TOKEN & CİHAZ (KARAR #11)
// ═══════════════════════════════════════════════════════════════════

/** Setup token geçerlilik süresi */
export const SETUP_TOKEN_GECERLILIK_SAAT = 48 as const

// ═══════════════════════════════════════════════════════════════════
// AVANS (Spec madde 13)
// ═══════════════════════════════════════════════════════════════════

/** Talep ayın hangi gününden sonra yapılabilir */
export const AVANS_TALEP_BASLANGIC_GUN = 15 as const

/** Aylık maksimum talep sayısı */
export const AVANS_AYLIK_MAX_TALEP = 2 as const

/** Aynı anda max aktif talep */
export const AVANS_AYNI_ANDA_MAX_AKTIF = 1 as const

/** Max avans = anlıkHakEdiş × yüzde */
export const AVANS_MAX_HAK_EDIS_YUZDE = 0.5 as const

// ═══════════════════════════════════════════════════════════════════
// PUANTAJ
// ═══════════════════════════════════════════════════════════════════

/** Sorumlu günlük puantaj limiti (TL) — BOSS değiştirebilir */
export const SORUMLU_GUNLUK_PUANTAJ_LIMITI_VARSAYILAN = 200 as const

/** Sorumlu kendi puantajını geri alma süresi (saat) */
export const SORUMLU_PUANTAJ_GERI_ALMA_SAAT = 1 as const

/** BOSS başkasının puantajını iptal etme süresi (saat) */
export const BOSS_PUANTAJ_IPTAL_SAAT = 24 as const

// ═══════════════════════════════════════════════════════════════════
// MAAŞ HESABI (Spec madde 10)
// ═══════════════════════════════════════════════════════════════════

/** Aylık maaşı saatliğe çevirmek için bölen */
export const AYLIK_STANDART_SAAT_VARSAYILAN = 300 as const

/** Default fazla mesai katsayısı */
export const FAZLA_MESAI_KATSAYISI_VARSAYILAN = 1.5 as const

// ═══════════════════════════════════════════════════════════════════
// AUDIT (KARAR #16, spec madde 17.3)
// ═══════════════════════════════════════════════════════════════════

/** KVKK uyumu için audit log saklama süresi */
export const AUDIT_SAKLAMA_YIL = 5 as const

/** Görev tamamlanma kayıt saklama süresi (gün) */
export const GOREV_KAYIT_SAKLAMA_GUN = 90 as const

// ═══════════════════════════════════════════════════════════════════
// BELGE (Spec madde 16)
// ═══════════════════════════════════════════════════════════════════

/** Max belge boyutu (bytes) */
export const BELGE_MAX_BOYUT = 10 * 1024 * 1024 as const  // 10 MB

/** Belge geçerlilik hatırlatma — kaç gün önce */
export const BELGE_HATIRLATMA_30_GUN = 30 as const
export const BELGE_HATIRLATMA_7_GUN = 7 as const

// ═══════════════════════════════════════════════════════════════════
// GÖREV (Spec madde 14)
// ═══════════════════════════════════════════════════════════════════

/** Görev kaçırılırsa ne kadar sonra BOSS'a eskaltasyon */
export const GOREV_KACIRMA_BOSS_BILDIRIM_DAKIKA = 60 as const

// ═══════════════════════════════════════════════════════════════════
// SAAT DİLİMİ
// ═══════════════════════════════════════════════════════════════════

/** KKTC saat dilimi (yıl boyu UTC+3 sabit, DST yok) */
export const SAAT_DILIMI = 'Europe/Istanbul' as const

// ═══════════════════════════════════════════════════════════════════
// PARA FORMATI (KARAR #27)
// ═══════════════════════════════════════════════════════════════════

/** KARAR #27: Avrupa stili — 8.450 ₺ */
export const PARA_FORMATI = {
  locale: 'de-DE',                   // de-DE = . binlik ayırıcı, , kuruş
  symbol: '₺',
  decimalPlaces: 2,
} as const

// ═══════════════════════════════════════════════════════════════════
// BİLDİRİM (KARAR #14, #26)
// ═══════════════════════════════════════════════════════════════════

/** BOSS sabah özeti gönderilme saati */
export const BOSS_SABAH_OZETI_SAAT = '09:00' as const

/** Doğum günü hatırlatma — BOSS'a kaç gün önce */
export const DOGUM_GUNU_HATIRLATMA_GUN_ONCE = 1 as const

/** Default sessiz saat aralığı (BOSS) */
export const VARSAYILAN_SESSIZ_SAAT_BASLANGIC = '22:00' as const
export const VARSAYILAN_SESSIZ_SAAT_BITIS = '08:00' as const

// ═══════════════════════════════════════════════════════════════════
// KAĞIT KKTC RESMİ TATİLLERİ (Önerilen liste — BOSS toplu kabul/red eder)
// ═══════════════════════════════════════════════════════════════════

/**
 * Spec madde 9.2: Sistem önerisi.
 * BOSS toplu kabul/red eder. Dini bayramlar her yıl ayrıca tanımlanır.
 */
export const KKTC_SABIT_RESMI_TATILLER = [
  { ay: 1,  gun: 1,  isim: 'Yılbaşı' },
  { ay: 4,  gun: 23, isim: 'Ulusal Egemenlik ve Çocuk Bayramı' },
  { ay: 5,  gun: 1,  isim: 'Emek ve Dayanışma Günü' },
  { ay: 5,  gun: 19, isim: 'Atatürk\u2019ü Anma, Gençlik ve Spor Bayramı' },
  { ay: 7,  gun: 20, isim: 'Barış ve Özgürlük Bayramı' },
  { ay: 8,  gun: 1,  isim: 'TMT Günü' },
  { ay: 8,  gun: 30, isim: 'Zafer Bayramı' },
  { ay: 10, gun: 29, isim: 'Cumhuriyet Bayramı' },
  { ay: 11, gun: 15, isim: 'KKTC Cumhuriyet Bayramı' },
] as const
